// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"

// Import SCSS
//import "../assets/stylesheets/application.scss"

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min"

import "./flash"
import "./flash_close"

import "./job_button"

import "./json_parse"

import "./channels/notification_channel"

// DateTime Picker
// Tempus Dominus CSS + fonts+icons for Tempus Dominus
//import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';
//import "@fortawesome/fontawesome-free/js/all";
//
// Flatpicker
import "flatpickr/dist/flatpickr.min.css";
